// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* html {
    height: 100%;
}
body {
    height: 100%;
    background: #ea4961;
    display: flex;
    align-items: center;
    justify-content: center;
} */
.loader {
    position: relative;
    width: 75px;
    height: 100px;
}
.loader__bar {
    position: absolute;
    bottom: 0;
    width: 10px;
    height: 50%;
    background: #dafe6a;
    transform-origin: center bottom;
    box-shadow: 1px 1px 0 rgba(0, 0, 0, .2);
}
.loader__bar:nth-child(1) {
    left: 0px;
    transform: scale(1, 0.2);
    animation: barUp1 4s infinite;
}
.loader__bar:nth-child(2) {
    left: 15px;
    transform: scale(1, 0.4);
    animation: barUp2 4s infinite;
}
.loader__bar:nth-child(3) {
    left: 30px;
    transform: scale(1, 0.6);
    animation: barUp3 4s infinite;
}
.loader__bar:nth-child(4) {
    left: 45px;
    transform: scale(1, 0.8);
    animation: barUp4 4s infinite;
}
.loader__bar:nth-child(5) {
    left: 60px;
    transform: scale(1, 1);
    animation: barUp5 4s infinite;
}
.loader__ball {
    position: absolute;
    bottom: 10px;
    left: 0;
    width: 10px;
    height: 10px;
    background: #fff;
    border-radius: 50%;
    animation: ball 4s infinite;
}
@keyframes ball {
    0% {
        transform: translate(0, 0);
   }
    5% {
        transform: translate(8px, -14px);
   }
    10% {
        transform: translate(15px, -10px);
   }
    17% {
        transform: translate(23px, -24px);
   }
    20% {
        transform: translate(30px, -20px);
   }
    27% {
        transform: translate(38px, -34px);
   }
    30% {
        transform: translate(45px, -30px);
   }
    37% {
        transform: translate(53px, -44px);
   }
    40% {
        transform: translate(60px, -40px);
   }
    50% {
        transform: translate(60px, 0);
   }
    57% {
        transform: translate(53px, -14px);
   }
    60% {
        transform: translate(45px, -10px);
   }
    67% {
        transform: translate(37px, -24px);
   }
    70% {
        transform: translate(30px, -20px);
   }
    77% {
        transform: translate(22px, -34px);
   }
    80% {
        transform: translate(15px, -30px);
   }
    87% {
        transform: translate(7px, -44px);
   }
    90% {
        transform: translate(0, -40px);
   }
    100% {
        transform: translate(0, 0);
   }
}
@keyframes barUp1 {
    0% {
        transform: scale(1, 0.2);
   }
    40% {
        transform: scale(1, 0.2);
   }
    50% {
        transform: scale(1, 1);
   }
    90% {
        transform: scale(1, 1);
   }
    100% {
        transform: scale(1, 0.2);
   }
}
@keyframes barUp2 {
    0% {
        transform: scale(1, 0.4);
   }
    40% {
        transform: scale(1, 0.4);
   }
    50% {
        transform: scale(1, 0.8);
   }
    90% {
        transform: scale(1, 0.8);
   }
    100% {
        transform: scale(1, 0.4);
   }
}
@keyframes barUp3 {
    0% {
        transform: scale(1, 0.6);
   }
    100% {
        transform: scale(1, 0.6);
   }
}
@keyframes barUp4 {
    0% {
        transform: scale(1, 0.8);
   }
    40% {
        transform: scale(1, 0.8);
   }
    50% {
        transform: scale(1, 0.4);
   }
    90% {
        transform: scale(1, 0.4);
   }
    100% {
        transform: scale(1, 0.8);
   }
}
@keyframes barUp5 {
    0% {
        transform: scale(1, 1);
   }
    40% {
        transform: scale(1, 1);
   }
    50% {
        transform: scale(1, 0.2);
   }
    90% {
        transform: scale(1, 0.2);
   }
    100% {
        transform: scale(1, 1);
   }
}



/* Secondary Loader CSS  */
/* HTML: <div class="loader"></div> */
.loader-secondary {
    width: 50px;
    aspect-ratio: 1;
    border-radius: 50%;
    border: 8px solid;
    border-color: white #0000;
    animation: l1 1s infinite;
  }
  @keyframes l1 {to{transform: rotate(.5turn)}}
`, "",{"version":3,"sources":["webpack://./src/components/loader.css"],"names":[],"mappings":"AAAA;;;;;;;;;GASG;AACH;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,+BAA+B;IAC/B,uCAAuC;AAC3C;AACA;IACI,SAAS;IACT,wBAAwB;IACxB,6BAA6B;AACjC;AACA;IACI,UAAU;IACV,wBAAwB;IACxB,6BAA6B;AACjC;AACA;IACI,UAAU;IACV,wBAAwB;IACxB,6BAA6B;AACjC;AACA;IACI,UAAU;IACV,wBAAwB;IACxB,6BAA6B;AACjC;AACA;IACI,UAAU;IACV,sBAAsB;IACtB,6BAA6B;AACjC;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,2BAA2B;AAC/B;AACA;IACI;QACI,0BAA0B;GAC/B;IACC;QACI,gCAAgC;GACrC;IACC;QACI,iCAAiC;GACtC;IACC;QACI,iCAAiC;GACtC;IACC;QACI,iCAAiC;GACtC;IACC;QACI,iCAAiC;GACtC;IACC;QACI,iCAAiC;GACtC;IACC;QACI,iCAAiC;GACtC;IACC;QACI,iCAAiC;GACtC;IACC;QACI,6BAA6B;GAClC;IACC;QACI,iCAAiC;GACtC;IACC;QACI,iCAAiC;GACtC;IACC;QACI,iCAAiC;GACtC;IACC;QACI,iCAAiC;GACtC;IACC;QACI,iCAAiC;GACtC;IACC;QACI,iCAAiC;GACtC;IACC;QACI,gCAAgC;GACrC;IACC;QACI,8BAA8B;GACnC;IACC;QACI,0BAA0B;GAC/B;AACH;AACA;IACI;QACI,wBAAwB;GAC7B;IACC;QACI,wBAAwB;GAC7B;IACC;QACI,sBAAsB;GAC3B;IACC;QACI,sBAAsB;GAC3B;IACC;QACI,wBAAwB;GAC7B;AACH;AACA;IACI;QACI,wBAAwB;GAC7B;IACC;QACI,wBAAwB;GAC7B;IACC;QACI,wBAAwB;GAC7B;IACC;QACI,wBAAwB;GAC7B;IACC;QACI,wBAAwB;GAC7B;AACH;AACA;IACI;QACI,wBAAwB;GAC7B;IACC;QACI,wBAAwB;GAC7B;AACH;AACA;IACI;QACI,wBAAwB;GAC7B;IACC;QACI,wBAAwB;GAC7B;IACC;QACI,wBAAwB;GAC7B;IACC;QACI,wBAAwB;GAC7B;IACC;QACI,wBAAwB;GAC7B;AACH;AACA;IACI;QACI,sBAAsB;GAC3B;IACC;QACI,sBAAsB;GAC3B;IACC;QACI,wBAAwB;GAC7B;IACC;QACI,wBAAwB;GAC7B;IACC;QACI,sBAAsB;GAC3B;AACH;;;;AAIA,0BAA0B;AAC1B,qCAAqC;AACrC;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,yBAAyB;EAC3B;EACA,eAAe,GAAG,yBAAyB,CAAC","sourcesContent":["/* html {\n    height: 100%;\n}\nbody {\n    height: 100%;\n    background: #ea4961;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n} */\n.loader {\n    position: relative;\n    width: 75px;\n    height: 100px;\n}\n.loader__bar {\n    position: absolute;\n    bottom: 0;\n    width: 10px;\n    height: 50%;\n    background: #dafe6a;\n    transform-origin: center bottom;\n    box-shadow: 1px 1px 0 rgba(0, 0, 0, .2);\n}\n.loader__bar:nth-child(1) {\n    left: 0px;\n    transform: scale(1, 0.2);\n    animation: barUp1 4s infinite;\n}\n.loader__bar:nth-child(2) {\n    left: 15px;\n    transform: scale(1, 0.4);\n    animation: barUp2 4s infinite;\n}\n.loader__bar:nth-child(3) {\n    left: 30px;\n    transform: scale(1, 0.6);\n    animation: barUp3 4s infinite;\n}\n.loader__bar:nth-child(4) {\n    left: 45px;\n    transform: scale(1, 0.8);\n    animation: barUp4 4s infinite;\n}\n.loader__bar:nth-child(5) {\n    left: 60px;\n    transform: scale(1, 1);\n    animation: barUp5 4s infinite;\n}\n.loader__ball {\n    position: absolute;\n    bottom: 10px;\n    left: 0;\n    width: 10px;\n    height: 10px;\n    background: #fff;\n    border-radius: 50%;\n    animation: ball 4s infinite;\n}\n@keyframes ball {\n    0% {\n        transform: translate(0, 0);\n   }\n    5% {\n        transform: translate(8px, -14px);\n   }\n    10% {\n        transform: translate(15px, -10px);\n   }\n    17% {\n        transform: translate(23px, -24px);\n   }\n    20% {\n        transform: translate(30px, -20px);\n   }\n    27% {\n        transform: translate(38px, -34px);\n   }\n    30% {\n        transform: translate(45px, -30px);\n   }\n    37% {\n        transform: translate(53px, -44px);\n   }\n    40% {\n        transform: translate(60px, -40px);\n   }\n    50% {\n        transform: translate(60px, 0);\n   }\n    57% {\n        transform: translate(53px, -14px);\n   }\n    60% {\n        transform: translate(45px, -10px);\n   }\n    67% {\n        transform: translate(37px, -24px);\n   }\n    70% {\n        transform: translate(30px, -20px);\n   }\n    77% {\n        transform: translate(22px, -34px);\n   }\n    80% {\n        transform: translate(15px, -30px);\n   }\n    87% {\n        transform: translate(7px, -44px);\n   }\n    90% {\n        transform: translate(0, -40px);\n   }\n    100% {\n        transform: translate(0, 0);\n   }\n}\n@keyframes barUp1 {\n    0% {\n        transform: scale(1, 0.2);\n   }\n    40% {\n        transform: scale(1, 0.2);\n   }\n    50% {\n        transform: scale(1, 1);\n   }\n    90% {\n        transform: scale(1, 1);\n   }\n    100% {\n        transform: scale(1, 0.2);\n   }\n}\n@keyframes barUp2 {\n    0% {\n        transform: scale(1, 0.4);\n   }\n    40% {\n        transform: scale(1, 0.4);\n   }\n    50% {\n        transform: scale(1, 0.8);\n   }\n    90% {\n        transform: scale(1, 0.8);\n   }\n    100% {\n        transform: scale(1, 0.4);\n   }\n}\n@keyframes barUp3 {\n    0% {\n        transform: scale(1, 0.6);\n   }\n    100% {\n        transform: scale(1, 0.6);\n   }\n}\n@keyframes barUp4 {\n    0% {\n        transform: scale(1, 0.8);\n   }\n    40% {\n        transform: scale(1, 0.8);\n   }\n    50% {\n        transform: scale(1, 0.4);\n   }\n    90% {\n        transform: scale(1, 0.4);\n   }\n    100% {\n        transform: scale(1, 0.8);\n   }\n}\n@keyframes barUp5 {\n    0% {\n        transform: scale(1, 1);\n   }\n    40% {\n        transform: scale(1, 1);\n   }\n    50% {\n        transform: scale(1, 0.2);\n   }\n    90% {\n        transform: scale(1, 0.2);\n   }\n    100% {\n        transform: scale(1, 1);\n   }\n}\n\n\n\n/* Secondary Loader CSS  */\n/* HTML: <div class=\"loader\"></div> */\n.loader-secondary {\n    width: 50px;\n    aspect-ratio: 1;\n    border-radius: 50%;\n    border: 8px solid;\n    border-color: white #0000;\n    animation: l1 1s infinite;\n  }\n  @keyframes l1 {to{transform: rotate(.5turn)}}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
